const confimeaDictIT = {
  headerPartnership: "Partnership",
  headerHelp: "Aiuto",
  headerBackToConfimea: "Torna al sito Confimea",
  heroBadge: "Benvenuti su Business Square di Confimea Imprese",
  heroTitle: "Attiva il tuo accesso digitale",
  heroTitleSpan: "con Business Square",
  heroText:
    "Se la tua azienda è associata a Confimea Imprese, richiedi l'accesso Manager e inizia subito a sfruttare i processi digitali di Business Square.",
  heroButton: "RICHIEDI ATTIVAZIONE MANAGER",
  heroStat1Value: "500+",
  heroStat1Label: "Aziende attive",
  heroStat2Value: "24h",
  heroStat2Label: "Attivazione rapida",
  heroStat3Value: "98%",
  heroStat3Label: "Soddisfazione clienti",
  benefitsBadge: "VANTAGGI ESCLUSIVI",
  benefitsTitle: "Perché attivare il profilo Manager sulla piattaforma Business Square?",
  benefitsSubtitle:
    "Strumenti pensati per digitalizzare e far crescere la tua azienda associata nella rete digitale.",
  benefit1Title: "Presenza digitale strutturata",
  benefit1Text:
    "Crea il profilo della tua azienda e gestisci la visibilità online con strumenti semplici e dedicati.",
  benefit2Title: "CashBack e fidelizzazione",
  benefit2Text:
    "Integra programmi di fidelizzazione per incentivare i clienti a tornare e aumentare le vendite.",
  benefit3Title: "Supporto dedicato Confimea",
  benefit3Text:
    "Accedi a un supporto prioritario dedicato ai membri Confimea Imprese per ogni esigenza.",
  benefit4Title: "Analytics e reportistica",
  benefit4Text:
    "Monitora le performance della tua attività con dashboard intuitive e report dettagliati.",
  benefit5Title: "Rete Business Square",
  benefit5Text:
    "Entra a far parte di una rete di aziende e accedi a opportunità di business e networking.",
  benefit6Title: "Certificazione digitale",
  benefit6Text:
    "Ottieni badge e certificazioni che attestano la tua appartenenza alla rete Business Square.",
  benefitLink: "Scopri di più",
  benefitsInfoBannerText: "Hai bisogno di più informazioni?",
  benefitsInfoBannerText2: "Contatta il nostro team e ti aiuteremo a iniziare.",
  benefitsInfoBannerButton: "Contatta il supporto",
  howItWorksBadge: "PROCESSO SEMPLICE",
  howItWorksTitle: "Come funziona l'attivazione del profilo Manager?",
  howItWorksSubtitle:
    "Tre passi semplici per attivare la digitalizzazione della tua azienda associata.",
  step1Title: "Compila il modulo",
  step1Text: "Inserisci i dati della tua azienda e le informazioni richieste per la verifica.",
  step1Link: "2 minuti",
  step2Title: "Verifica e approvazione",
  step2Text: "Il tuo profilo verrà verificato dal team per confermare la tua appartenenza.",
  step2Link: "24-48 ore",
  step3Title: "Attivazione immediata",
  step3Text: "Ricevi l'accesso alla piattaforma e inizia subito a gestire la tua attività.",
  step3Link: "Immediato",
  ctaBadge: "Inizia oggi stesso",
  ctaTitle: "Pronto per iniziare?",
  ctaText:
    "Con pochi semplici passi puoi attivare l'accesso alla piattaforma Business Square e iniziare a gestire la tua attività in modo digitale e professionale.",
  ctaButton: "Compila il modulo",
  formBadge: "Registrazione rapida",
  formTitle: "Richiedi l'accesso Manager",
  formSubtitle:
    "Compila il form e in 24 ore riceverai l'attivazione del tuo account come Manager nella piattaforma.",
  formCompanyLabel: "Nome Azienda/Ente",
  formCompanyPlaceholder: "Es. Studio Medico Rossi",
  formNameLabel: "Nome e Cognome",
  formNamePlaceholder: "Mario Rossi",
  formEmailLabel: "Email aziendale",
  formEmailPlaceholder: "nome@azienda.it",
  formPasswordLabel: "Password",
  formPasswordPlaceholder: "Crea una password sicura",
  formPartnerCodeLabel: "Codice Partner",
  formPartnerCodeOptional: "(opzionale)",
  formPartnerCodePlaceholder: "Se hai un codice partner, inseriscilo qui",
  formAcceptTerms: "Accetto i",
  formTermsLink: "Termini e Condizioni",
  formAnd: "e la",
  formPrivacyLink: "Privacy Policy",
  formTermsSuffix: "di Extraconomy e Confimea Imprese.",
  formAcceptMarketing:
    "Acconsento a ricevere comunicazioni commerciali e aggiornamenti sui servizi.",
  formSubmit: "Invia richiesta di attivazione",
  formCaptcha: "Protetto da reCAPTCHA - Privacy e Termini di Google",
  partnershipBadge: "Partnership ufficiale",
  partnershipTitle: "Partnership ufficiale",
  partnershipSubtitle:
    "Un canale dedicato esclusivamente alle aziende associate a Confimea Imprese per accedere a digitalizzazione e a funzionalità attive.",
  partnershipLink1: "Vedi tutti i vantaggi",
  partnershipLink2: "Registrati ora",
  faqBadge: "FAQ",
  faqTitle: "Domande frequenti",
  faqSubtitle: "Trova risposte alle domande più comuni sulla partnership e l'attivazione.",
  faq1Question: "Chi può accedere quando attiva un'attivazione?",
  faq1Answer:
    "Solo le aziende ufficialmente associate a Confimea Imprese possono compilare questo modulo. Durante il processo di verifica, controlleremo attentamente il codice associato fornito per confermare l'appartenenza alla rete e garantire l'accesso ai vantaggi esclusivi della partnership.",
  faq2Question: "È incluso del servizio attivo/assistenza il piano Manager?",
  faq2Answer:
    "No. Dopo l'invio del modulo, il nostro team verifica accuratamente i dati e l'associazione a Confimea Imprese. Successivamente ti contattiamo per completare l'attivazione e fornirti le credenziali di accesso. Il processo di verifica richiede tipicamente 24-48 ore lavorative, ma lavoriamo per essere il più veloci possibile.",
  faq3Question: "È necessario personale tecnico per utilizzare la piattaforma?",
  faq3Answer:
    "Assolutamente no. Business Square è stata progettata specificamente per gestori d'impresa, con un'interfaccia intuitiva e semplice da usare. Non serve alcuna esperienza tecnica particolare. Inoltre, offriamo formazione iniziale completa e supporto dedicato per tutti i nuovi Manager, garantendo un onboarding fluido e produttivo.",
  faq4Question: "Quali sono i costi associati al piano Manager?",
  faq4Answer:
    "Per le aziende associate a Confimea Imprese, il piano Manager include condizioni speciali concordate nella partnership. Il nostro team fornirà tutti i dettagli sui costi e le condizioni durante il processo di attivazione, insieme a una presentazione completa delle funzionalità disponibili.",
  faq5Question: "Posso cancellare l'accesso Manager in qualsiasi momento?",
  faq5Answer:
    "Sì, hai piena libertà di gestire il tuo accesso. Puoi richiedere la sospensione o cancellazione in qualsiasi momento contattando il supporto dedicato. Non ci sono vincoli contrattuali rigidi, e il nostro obiettivo è sempre garantire la massima soddisfazione e flessibilità per i partner.",
  contactTitle: "Hai altre domande?",
  contactText:
    "Il nostro team è pronto ad aiutarti e a rispondere a ogni tua domanda in tempo reale.",
  contactButton1: "Contattaci adesso",
  contactButton2: "Vai alle FAQ",
  footerPartnership: "Partnership",
  footerLink1: "Per Imprese Associate",
  footerLink2: "Come funziona",
  footerLink3: "FAQ",
  footerQuickLinks: "Link rapidi",
  footerLink4: "Sito Extraconomy",
  footerLink5: "Richiedi accesso",
  footerLink6: "Assistenza",
  footerContacts: "Contatti",
  footerCopyright: "Extraconomy Global srl - P.IVA 16948681008 - Tutti i diritti riservati",
  email: "Email",
  fullName: "Nome e Cognome",
  formSuccessBadge: "Registrazione completata",
  formSuccessTitle: "Verifica la tua email",
  formSuccessSubtitle:
    "Ti abbiamo inviato un link di conferma alla tua email. Clicca sul link per attivare il tuo account Manager e iniziare a utilizzare la piattaforma Business Square.",
  formSuccessMessage: "Abbiamo inviato un'email di conferma a:",
  formSuccessNote:
    "Controlla la tua casella di posta e attiva il tuo account tramite il link inviato nell'email.",
  formSuccessStep1: "Apri l'email che ti abbiamo inviato",
  formSuccessStep2: "Clicca sul pulsante di conferma",
  formSuccessStep3: "Verrai reindirizzato al login della piattaforma",
  formSuccessEmailNotReceived:
    "Non hai ricevuto l'email? Controlla la tua cartella spam.",
  emailVerified: "Email Verificata!",
  completeActivationSubtitle: "Completa l'attivazione inviando la documentazione richiesta",
  requiredDocuments: "Documenti necessari per l’attivazione completa",
  document1: "Per completare la validazione della tua iscrizione a Confimea Imprese su Business Square, ti chiederemo questi documenti.",
  document2: "Puoi prepararli e inviarli con calma: non è necessario farlo subito.",
  document3: "Scarica il modulo, compilalo e firmalo. Potrai caricare il modulo e gli altri documenti nella tua area personale quando ti è più comodo.",
  downloadTemplateDocument: "SCARICA DOCUMENTO MODELLO",
  uploadYourDocuments: "Carica i tuoi documenti",
  uploadedFiles: "File caricati",
  ready: "Pronto",
  chooseFile: "Scegli file",
  dragFilesHereOrClick: "Trascina i file qui o clicca per selezionare",
  fileFormatsHint: "PDF, JPG, PNG (Max 10MB per file)",
  documentsVerificationInfo:
    "I documenti saranno verificati entro 24 ore lavorative. Riceverai una conferma via email.",
  skipAndGoToLogin: "SALTA E VAI AL LOGIN",
  sendDocumentation: "INVIA DOCUMENTAZIONE",
  privacyNote: "I tuoi documenti saranno trattati in modo confidenziale secondo le normative GDPR.",
  confirmingEmail: "Confermando email...",
  confirmationMissingParams: "Parametri di conferma mancanti",
  confirmationError: "Errore durante la conferma dell'email",
  fileUploadedSuccessfully: "File caricato con successo",
  pleaseUploadDocument: "Si prega di caricare un documento",
  documentSentSuccessfully: "Documentazione inviata con successo",
  confirmationDocumentDescription: "Documentazione di attivazione Confimea Imprese",
  goToLogin: "Vai al Login",
  removeFile: "Rimuovi",
  documentsReceived: "DOCUMENTI RICEVUTI",
  documentationSentSuccessfully: "Documentazione inviata con successo!",
  documentationSentSuccessfullySubtitle:
    "Grazie per aver inviato i tuoi documenti. Il nostro team di verifica inizierà il processo di validazione.",
  emailConfirmation: "Conferma via email",
  emailConfirmationDescription: "Riceverai una email di conferma ricezione all'indirizzo fornito.",
  verificationTime: "Tempo di verifica",
  verificationTimeDescription: "Il processo di verifica richiede solitamente 24-48 ore lavorative.",
  activationNotification: "Notifica di attivazione",
  activationNotificationDescription:
    "Una volta approvato, riceverai le credenziali di accesso via email.",
  whatHappensNow: "Cosa succede ora?",
  whatHappensNow1: "Il team Confimea Imprese verificherà i documenti inviati",
  whatHappensNow2: "Se necessario, potremmo contattarti per ulteriori chiarimenti",
  whatHappensNow3: "Riceverai le credenziali di accesso alla piattaforma Manager",
  whatHappensNow4: "Potrai iniziare a gestire i tuoi clienti e i loro documenti",
  goToLoginPage: "VAI ALLA PAGINA DI LOGIN",
  associationDocumentUnavailable:
    "Impossibile caricare il documento dell'associazione. Riprova più tardi.",
  paymentSummary: "Riepilogo dell'operazione:",
  preferPayPal: "Se preferisci, paga con PayPal",
};

export default confimeaDictIT;
